// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import OrderListTemplate from 'components/order/OrderListTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OrdersActions } from '../../store/actionCreators';

type Props = {
  orders: any,
};

class OrderListTemplateContainer extends Component<Props> {
  initialize = async () => {
    try {
      await OrdersActions.listOrder();
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  onClick = (to) => {
    this.props.history.push(to);
  };

  downloadRequestsExcel = async () => {
    const result = await OrdersActions.downloadRequestsExcel();
    this.download(result.data);
  };

  downloadInventoriesExcel = async () => {
    const result = await OrdersActions.downloadInventoriesExcel();
    this.download(result.data);
  };

  download(url) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const name = new URL(url).pathname.split('/').pop();
        link.download = decodeURIComponent(name);
        link.click();
      })
      .catch(console.error);
  }

  render() {
    if (!this.props.orders.items.length && (this.props.loading === undefined || this.props.loading))
      return <Circles color="blue" size="medium" text="Loading..." />;
    return (
      <OrderListTemplate
        orders={this.props.orders}
        onClick={this.onClick}
        downloadRequestsExcel={this.downloadRequestsExcel}
        downloadInventoriesExcel={this.downloadInventoriesExcel}
      />
    );
  }
}

export default connect(
  ({ orders, pender }: State) => ({
    orders,
    loading: pender.pending['orders/LIST_ORDER'],
  }),
  () => ({}),
)(withRouter(OrderListTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/order/OrderListTemplateContainer.js